module.exports = __webpack_public_path__ + "static/img/model-icon_light.3ef3c413.png";